import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Collapse, Stack } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

/**
 * The full text the shop's self-updater printed (auth result `output`): the
 * same lines /server/v1/scripts/application/update shows when opened in a
 * browser — skipped versions, download, extract, cleanup, migrations, statics.
 * The step list above it only holds a summary. Open by default after a
 * failure, folded after a success.
 */
const UpdaterLog = ({ output, failed, tr, notify }) => {
    const [open, setOpen] = useState(!!failed);
    if (!output) return null;
    const lines = output.split('\n').length;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(output);
            if (notify) notify(tr('cfg_setup_updater_log_copied', 'Updater-log gekopieerd.'), 2000);
        } catch (e) { /* clipboard blocked: the text stays selectable */ }
    };

    return (
        <Box data-updater-log>
            <Stack direction="row" spacing={1} alignItems="center">
                <Button size="small" onClick={() => setOpen(v => !v)} sx={{ textTransform: 'none' }}
                    startIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
                    {open
                        ? tr('cfg_setup_updater_log_hide', 'Updater-log verbergen')
                        : tr('cfg_setup_updater_log_show', 'Updater-log tonen') + ` (${lines})`}
                </Button>
                {open && (
                    <Button size="small" onClick={copy} sx={{ textTransform: 'none' }} startIcon={<ContentCopyIcon sx={{ fontSize: 16 }} />}>
                        {tr('cfg_setup_updater_log_copy', 'Kopiëren')}
                    </Button>
                )}
            </Stack>
            <Collapse in={open} unmountOnExit>
                <Box component="pre" sx={{
                    m: 0, mt: 0.5, p: 1.5, maxHeight: 360, overflow: 'auto',
                    bgcolor: 'action.hover', border: '1px solid', borderColor: 'divider', borderRadius: 1,
                    fontFamily: 'ui-monospace, SFMono-Regular, Consolas, monospace', fontSize: '0.75rem', lineHeight: 1.5,
                    whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                }}>
                    {output}
                </Box>
            </Collapse>
        </Box>
    );
};

UpdaterLog.propTypes = {
    output: PropTypes.string, failed: PropTypes.bool, tr: PropTypes.func.isRequired, notify: PropTypes.func,
};

export default UpdaterLog;
